import ReactStrapTable from "components/reactStrapTable";
import React, { useState } from "react";

import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Row,
  Tooltip,
} from "reactstrap";
import { cellRendererCheck, dateFormate } from "utils/columns";
import { Formik } from "formik";
import searchIcon from "assets/icon/search.svg";
import sortIcon from "assets/icon/sort-arrow.svg";
import columnSelectorIcon from "assets/icon/column-selector.svg";
import { useNavigate } from "react-router-dom";
import plusIcon from "assets/icon/plus-rx.svg";
import resetAllIcon from "../../../assets/icon/resetall.svg";
import applyIcon from "../../../assets/icon/apply.svg";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import PackagingInfoDetails from "pages/Packaging/PackagingInfoDetails";
import purpleCrossIcon from "assets/icon/purple-cross-icon.svg";
import iconStatus from "assets/icon/status-save-icon.svg";
import { OverlayTrigger } from "react-bootstrap";
import DescriptionTooltip from "components/reactStrapTable/components/DescriptionTooltip";
import { click } from "@testing-library/user-event/dist/click";
import DescriptionShort from "components/DescriptionShort";
import SearchButtons from "components/SearchButtons";

const currentStep = 4;
const numSteps = 9;
const rowData = [
  {
    id: "1",
    status: "Waiting",
    receiveddata: "Today, 11:23 AM",
    due: "12:23 PM",
    patient: "Doe, John",
    description: "NEWRX: Venlafaxine ER Tablet 150 MG",
    source: "Surescripts",
    backgroundColor: "red",
    dob: "01/08/1996",
  },
  {
    id: "2",
    status: "Due Soon",
    receiveddata: "Today, 11:28 AM",
    due: "12:28 PM",
    patient: "Brown, Mary",
    description: "Scanned Document",
    source: "Drop Off",
    dob: "01/08/1996",
  },
  {
    id: "3",
    status: "Due Soon ",
    receiveddata: "Today, 11:33 AM  ",
    due: "12:33 PM ",
    patient: "Wilson, Sarah",
    description: "CANRX: LISINOPRIL TAB 10MG ",
    source: "Surescripts",
    dob: "01/08/1996",
  },
  {
    id: "4",
    status: "Due Soon ",
    receiveddata: "Today, 11:38 AM ",
    due: "12:38 PM ",
    patient: "Adams, Aria  ",
    description: "CANRX: Levothyroxine Sodium Tablet 75MCG",
    source: "Surescripts",
    dob: "01/08/1996",
  },
  {
    id: "5",
    status: "New",
    receiveddata: "Today, 11:43 AM ",
    due: "12:43 PM ",
    patient: "Kim, Jacob ",
    description: "Scanned Document ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "6",
    status: "New",
    receiveddata: "Today, 11:48 AM ",
    due: "12:48 PM ",
    patient: "Baker, Ethan",
    description: "From: Dr. Alvarez ",
    source: "E-Fax ",
    dob: "01/08/1996",
  },
  {
    id: "7",
    status: "New",
    receiveddata: "Today, 12:03 PM  ",
    due: "01:03 PM ",
    patient: "White, Mason ",
    description: "Scanned Document  ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "8",
    status: "New",
    receiveddata: "Today, 12:08 PM  ",
    due: "01:08 PM  ",
    patient: "Scott, Lucas ",
    description: "Scanned Document ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "9",
    status: "New",
    receiveddata: "Today, 12:13 PM  ",
    due: "01:13 PM  ",
    patient: "Taylor, Jessica",
    description: "NEWRX: Omeprazole DR Capsule 20MG  ",
    source: "Surescripts  ",
    dob: "01/08/1996",
  },
  {
    id: "10",
    status: "New",
    receiveddata: "Today, 12:18 PM ",
    due: "01:18 PM ",
    patient: "Harris, Emily ",
    description: "[Pending Transcription] ",
    source: "Voicemail  ",
    dob: "01/08/1996",
  },
  {
    id: "11",
    status: "New",
    receiveddata: "Today, 12:33 PM   ",
    due: " 1:33 PM ",
    patient: "Walker, Mia  ",
    description: "From: Dr. Nguyen ",
    source: "E-Fax  ",
    dob: "01/08/1996",
  },
  {
    id: "12",
    status: "New",
    receiveddata: "Today, 12:43 PM   ",
    due: "1:43 PM  ",
    patient: "Hill, Harper  ",
    description: "Scanned Document  ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "13",
    status: "New",
    receiveddata: "Today, 12:48 PM  ",
    due: "1:48 PM  ",
    patient: "Walker, Mia ",
    description: "Scanned Document  ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "14",
    status: "New",
    receiveddata: "Today, 12:53 PM   ",
    due: "1:53 PM   ",
    patient: "Lewis, James  ",
    description: "Scanned Document  ",
    source: "Drop Off ",
    dob: "01/08/1996",
  },
  {
    id: "15",
    status: "New",
    receiveddata: "Today, 01:03 PM   ",
    due: "2:03 PM  ",
    patient: "Patel, Aarav   ",
    description: "NEWRX: Sertraline HCL Tablet 100MG ",
    source: "Surescripts  ",
    dob: "01/08/1996",
  },
  {
    id: "16",
    status: "New",
    receiveddata: "Today, 01:08 PM  ",
    due: "2:08 PM   ",
    patient: "Young, Noah ",
    description: "From: Dr. Nguyen  ",
    source: "E-Fax ",
    dob: "01/08/1996",
  },
  {
    id: "17",
    status: "New",
    receiveddata: "Today, 01:13 PM   ",
    due: "2:13 PM  ",
    patient: "Hill, Harper  ",
    description: "From: Dr. Samuels",
    source: "E-Fax  ",
    dob: "01/08/1996",
  },
  {
    id: "16",
    status: "New",
    receiveddata: "Today, 01:18 PM",
    due: "2:18 PM ",
    patient: "King, Liam   ",
    description: "CANRX: Levothyroxine Sodium Tablet 75MCG ",
    source: "Surescripts ",
    dob: "01/08/1996",
  },
  {
    id: "17",
    status: "New",
    receiveddata: "Today, 01:23 PM ",
    due: "2:23 PM ",
    patient: "Jackson, Olivia   ",
    description: "Scanned Document  ",
    source: "Drop Off",
    dob: "01/08/1996",
  },
];

const render = (rowData) => {
  return <VerticalStatusPopover row={rowData} />;
};
let colData = [
  {
    dataField: "status",
    text: "Order Status",
    width: 60,
    show: true,
    sort: true,
    // disabled: true,
    // hideColFilter: true,
    // action: true,
    cellRenderer: (rowData) => render(rowData),
  },
  {
    dataField: "receiveddata",
    text: "Received Date",
    width: 90,
    show: true,
    sort: true,
    // disabled: true,
    hideColFilter: false,
    // action: true,
  },

  {
    dataField: "due",
    text: "Due",
    sort: true,
    width: 90,
    show: true,
  },
  {
    dataField: "patient",
    text: "Patient",
    sort: true,
    width: 100,
    show: true,
    // cellRenderer: (rowData) => (
    //   <a href="/patient-details" style={{ color: "#212529" }}>
    //     {rowData.patient}
    //   </a>
    // ),
  },
  {
    dataField: "description",
    text: "Description",
    sort: true,
    width: 210,
    show: true,
    // cellRenderer: (rowData) => DescriptionShort(rowData),
  },
  {
    dataField: "source",
    text: "Source",
    sort: true,
    width: 80,
    show: true,
  },
  {
    dataField: "dob",
    text: "DOB",
    show: false,
    width: 80,

  },
];

const PatientsReportTable = () => {
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(rowData);
  const [columnOpen, setColumnOpen] = useState(false);
  const [updateData, setUpdateData] = useState([]);
  const [openListOverlay, setOpenListOverLay] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [rSelected, setRSelected] = useState("off");

  const handleClickLink = () => {
    navigate("/workflow-orderEntry-createNewRx");
  };
  // const onClickNavigate = () => {
  //   navigate("/patient-details");
  // };

  const handleRowClick = (row) => {
    navigate(`/workflow-orderEntry/patient-details/${row.id}`, { state: row });
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const [check, setCheck] = useState({
    selectall: false,
    status: false,
    receiveddata: false,
    description: false,
    source: false,
    patient: false,
    due: false,
  });

  const handleChange = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        status: checked,
        receiveddata: checked,
        description: checked,
        source: checked,
        patient: checked,
        due: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };
  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 0;
        if (key === "receiveddata") return 1;
        if (key === "due") return 2;
        if (key === "patient") return 3;
        if (key === "description") return 4;
        if (key === "source") return 5;
        return -1;
      })
      .filter((index) => index !== -1);
    return colData.filter((_, index) => columnIndexes.includes(index));
  };

  const filteredColData = filterColumns();

  const totalCount = [
    check.status,
    check.receiveddata,
    check.description,
    check.source,
    check.patient,
    check.due,
  ].filter(Boolean).length;

  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colData);
    setColumnOpen(false);
  };

  const rowStyle = (row, rowIndex) => {
    if (rowIndex === 0) {
      return { backgroundColor: row.backgroundColor };
    }
    return {};
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        return {
          id: patient.id,
          status: (
            <>
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),

          id: patient.id,
          status: patient.status,
          receiveddata: patient.receiveddata,
          due: patient.due,
          patient: patient.patient,
          description: patient.description,
          source: patient.source,
          dob: patient.dob,
          //medication: user.username,
        };
      })
    : [
        {
          id: "",
          status: "",
          receiveddata: "",
          due: "",
          patient: "",
          description: "",
          source: "",
          dob: "",
          //medication: user.username,
        },
      ];

  return (
    <div className="bg-white table-card scroll-table layout-alignment position-relative border-0 rounded pb-0">
      <div className="heading-text section-devider-border pb-2 mb-2">
        Order Entry Queue
      </div>
      <Row>
        <Col
          lg={10}
          className="d-flex justify-content-start align-items-center"
          style={{ gap: "12px" }}
        >
          <div>
            <SearchButtons
              InSize={320}
              placeHolder={"Search by Patient, Drug, or Rx Number"}
              data={tableData}
              row={rowData}
              setFilterData={setTableData}
            />
          </div>
          <Dropdown
            isOpen={columnOpen}
            toggle={() => setColumnOpen(!columnOpen)}
          >
            <DropdownToggle className="">
              <img src={columnSelectorIcon} alt="not available" />
              <span>
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border mb-0 drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  // checked={check.due || check.patient || check.medication || check.payer || check.rxNum || check.rejection || check.submit}
                  onChange={handleChange}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="status"
                  value={check.status}
                  checked={check.status}
                  onChange={handleChange}
                />
                <span className="m-2">Status</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="receiveddata"
                  value={check.receiveddata}
                  checked={check.receiveddata}
                  onChange={handleChange}
                />
                <span className="m-2">Received Date</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="description"
                  value={check.description}
                  checked={check.description}
                  onChange={handleChange}
                />
                <span className="m-2">Description</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  value={check.source}
                  name="source"
                  checked={check.source}
                  onChange={handleChange}
                />
                <span className="m-2">Source</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  checked={check.patient}
                  value={check.patient}
                  name="patient"
                  onChange={handleChange}
                />
                <span className="m-2">Patient</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border  drp-down-clm-item">
                <Input
                  type="checkbox"
                  checked={check.due}
                  value={check.due}
                  name="due"
                  onChange={handleChange}
                />
                <span className="m-2">Due</span>
              </DropdownItem>

              <div className="d-flex justify-content-center align-items-center p-2">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      status: false,
                      receiveddata: false,
                      description: false,
                      source: false,
                      patient: false,
                      due: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" />
                  Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleChange}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <Button color="primary" className="" onClick={handleClickLink}>
            <img src={plusIcon} alt="Icon" /> Create New Rx
          </Button>
        </Col>
      </Row>

      <div fixed-height={rowData?.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="order-entry"
          height={550}
          row={rowData}
          width={1200}
          // reset={reset}
          data={tableFilterData}
          columns={updateData.length > 0 ? updateData : colData}
          handleRowClick={handleRowClick}
          enablerowRouting={true}
          rowStyle={rowStyle}
          redRow={[0]}
          yellowRow={[1, 2, 3]}
        />
      </div>
    </div>
  );
};

export default PatientsReportTable;
